/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmResolvedTarget {
    getFixupPrototypeFunction() { return AwsSsmResolvedTarget.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmResolvedTarget>): AwsSsmResolvedTarget {
        let obj = Object.assign(new AwsSsmResolvedTarget(), model);
        AwsSsmResolvedTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmResolvedTarget>): AwsSsmResolvedTarget {
        if (!model) return null;
        return AwsSsmResolvedTarget.newInstance(<AwsSsmResolvedTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmResolvedTarget) {
        if (!obj) return;

        models.AwsSsmResolvedTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmResolvedTarget): boolean {
        Object.setPrototypeOf(obj, AwsSsmResolvedTarget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Parameter values of the target resources.
     */
    parameter_values: Array<string>;

    /**
     * Status if the step is truncated.
     */
    truncated: boolean;

}
